import guaranteedAprContent from '@components/CreditCardContent/components/guaranteedAprContent'
import minimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/minimumGuaranteedCreditLimitContent'
import noMinimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/noMinimumGuaranteedCreditLimitContent'
import representativeAprContent from '@components/CreditCardContent/components/representativeAprContent'

import { getFormattedAPR } from '@utils/formatter'

import type { ContentProps } from './Content.interface'

const getTravelContent = ({ creditCard }: ContentProps) => {
    return [
        guaranteedAprContent({ creditCard }),
        minimumGuaranteedCreditLimitContent({ creditCard }),
        representativeAprContent({ creditCard }),
        noMinimumGuaranteedCreditLimitContent({
            creditCard,
        }),
        {
            title: 'International Fee',
            value: getFormattedAPR(creditCard.offerDetail.internationalCharges),
            detailType: undefined,
        },
    ]
}

export default getTravelContent
